var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 32,
    viewBox: "0 0 144 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4024_2000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7078 7.9294C51.5689 7.55637 51.4335 7.20529 51.3129 6.8798C51.1885 6.55432 51.0495 6.2398 50.8923 5.93626C50.735 5.63271 50.5558 5.34379 50.3547 5.07316C50.1535 4.80253 49.9122 4.53191 49.6306 4.26859C49.1807 3.84802 48.7199 3.54813 48.2555 3.36893C47.7874 3.18973 47.2607 3.10196 46.6683 3.10196C45.7833 3.10196 45.0299 3.27385 44.4155 3.61396C43.8011 3.95773 43.2379 4.45511 42.7222 5.10608C42.053 5.96186 41.5666 6.9054 41.263 7.94037C40.9595 8.97535 40.8095 10.0615 40.8095 11.1952C40.8095 12.1753 40.9229 13.1335 41.1497 14.0661C41.3764 14.9987 41.7348 15.8252 42.2249 16.5383C42.7149 17.2515 43.3476 17.8293 44.1266 18.2645C44.9055 18.6997 45.8527 18.9191 46.9755 18.9191C47.7691 18.9191 48.5407 18.7838 49.2868 18.5095C50.0329 18.2389 50.6326 17.7817 51.0825 17.1454C51.5323 16.5091 51.8687 15.6204 52.0845 14.4867L52.3405 14.5342C52.2162 15.6533 51.9163 16.6005 51.4409 17.3685C50.9654 18.1401 50.223 18.7253 49.2137 19.1312C48.7638 19.3177 48.2774 19.4567 47.7545 19.5518C47.2315 19.6469 46.7012 19.6908 46.1563 19.6908C45.6114 19.6908 45.0701 19.6469 44.5325 19.5628C43.9949 19.4787 43.4866 19.358 43.0038 19.2007C42.1627 18.9191 41.4276 18.5315 40.7986 18.0341C40.1695 17.5367 39.6393 16.9479 39.2114 16.2713C38.7835 15.5948 38.4653 14.8524 38.2532 14.0441C38.0447 13.2359 37.9387 12.3875 37.9387 11.4988C37.9387 10.8441 37.9972 10.1895 38.1142 9.52757C38.2313 8.86563 38.4141 8.2366 38.6628 7.63683C38.9115 7.03706 39.2187 6.47386 39.5844 5.94357C39.9501 5.41328 40.389 4.94882 40.9046 4.54288C41.6653 3.95042 42.543 3.49328 43.5305 3.16779C44.5179 2.84231 45.5017 2.67773 46.4818 2.67773C47.2278 2.67773 47.8788 2.75453 48.431 2.91179C48.9833 3.06905 49.4623 3.21533 49.8646 3.35431C50.2706 3.49328 50.6034 3.59202 50.8667 3.64688C51.13 3.70173 51.3348 3.62859 51.4738 3.42379C51.5359 3.36162 51.6054 3.22996 51.6822 3.02882L51.7042 3.05076V7.9294H51.7078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8971 2.68164V2.70358C65.2754 2.7365 64.7857 2.84255 64.4274 3.02907C64.0686 3.21558 63.7983 3.47158 63.6114 3.80073C63.4251 4.12987 63.308 4.51387 63.2606 4.95638C63.2131 5.3989 63.1909 5.89259 63.1909 6.43751V15.9351C63.1909 16.48 63.2131 16.9737 63.2606 17.4162C63.308 17.8588 63.4251 18.2464 63.6114 18.5719C63.7983 18.8974 64.0686 19.157 64.4274 19.3436C64.7857 19.5301 65.2686 19.6398 65.8754 19.6691H57.8223C58.4149 19.6398 58.9303 19.4935 59.3731 19.2375C59.8154 18.9815 60.1154 18.5353 60.2726 17.8953C60.3017 17.6759 60.3349 17.4089 60.368 17.0908C60.3971 16.7726 60.4154 16.3886 60.4154 15.9351V6.43751C60.4154 5.80117 60.3823 5.23067 60.32 4.7333C60.2583 4.23593 60.0571 3.80804 59.7131 3.44964C59.4497 3.16804 59.1537 2.98153 58.8246 2.8901C58.4989 2.79501 58.1257 2.7365 57.7051 2.70358V2.68164H65.8971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.82 3.07661C77.4469 3.07661 77.0446 3.08393 76.6172 3.09855C76.1892 3.11318 75.7646 3.14244 75.344 3.17901C74.9235 3.21924 74.5177 3.2741 74.1303 3.34358C73.7423 3.41307 73.4057 3.5045 73.128 3.61055C72.3817 3.92141 71.8263 4.4261 71.4606 5.12827C71.0949 5.82677 70.8275 6.59842 70.656 7.43957H70.608V2.68164H87.9246V7.44322H87.9029C87.7017 6.43019 87.4057 5.63295 87.0177 5.05147C86.6303 4.46998 86.1326 4.03113 85.5366 3.74587C84.9372 3.45695 84.2309 3.2741 83.412 3.1973C82.5966 3.1205 81.6566 3.08027 80.5995 3.08027V15.8876C80.5995 16.4471 80.6252 16.9518 80.68 17.4053C80.7349 17.8551 80.8555 18.2428 81.0423 18.5609C81.2286 18.8791 81.4995 19.1315 81.8577 19.318C82.216 19.5045 82.6989 19.6142 83.3057 19.6435V19.6654H75.1137V19.6435C75.7355 19.6142 76.2257 19.5045 76.584 19.318C76.9423 19.1315 77.2132 18.8791 77.3995 18.5609C77.5863 18.2428 77.7029 17.8588 77.7509 17.4053C77.7983 16.9518 77.82 16.4471 77.82 15.8876V3.07661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.076 15.9132C98.076 16.4727 98.1018 16.9774 98.1566 17.4309C98.2115 17.8807 98.332 18.2684 98.5189 18.5865C98.7052 18.9047 98.976 19.157 99.3343 19.3436C99.6926 19.5301 100.183 19.6398 100.805 19.6691V19.691H92.6126V19.6691C93.2343 19.6398 93.728 19.5264 94.0938 19.3289C94.4595 19.1351 94.7263 18.8755 94.8983 18.5463C95.0703 18.2208 95.18 17.8332 95.2235 17.3906C95.2715 16.9481 95.2932 16.4544 95.2932 15.9095V6.43751C95.2932 5.87797 95.2715 5.3733 95.2235 4.91981C95.176 4.46633 95.0589 4.08233 94.8726 3.76415C94.6863 3.44598 94.412 3.19364 94.0572 3.00713C93.6989 2.82061 93.216 2.7109 92.6086 2.68164H101.989C102.812 2.68164 103.551 2.79867 104.206 3.03273C104.86 3.26678 105.434 3.75684 105.932 4.5029C106.275 5.00027 106.495 5.54884 106.597 6.14859C106.7 6.74837 106.67 7.33717 106.517 7.92231C106.359 8.50745 106.085 9.04139 105.687 9.53145C105.288 10.0215 104.758 10.3982 104.089 10.6615C103.902 10.7383 103.683 10.8188 103.434 10.8956C103.185 10.9724 102.903 11.0455 102.593 11.104C102.966 11.2613 103.266 11.4185 103.493 11.5831C103.719 11.7477 103.909 11.9342 104.063 12.1427C104.217 12.3511 104.363 12.5961 104.494 12.8777C104.626 13.1593 104.787 13.4921 104.974 13.8798C105.175 14.3004 105.398 14.7575 105.639 15.2549C105.881 15.7522 106.122 16.235 106.363 16.7031C106.605 17.1712 106.842 17.6028 107.077 17.9977C107.31 18.3927 107.511 18.6926 107.683 18.8974C107.903 19.1607 108.111 19.3472 108.313 19.4569C108.514 19.5666 108.788 19.6361 109.128 19.6654V19.6873H104.787C104.615 19.3289 104.429 18.912 104.227 18.4403C104.026 17.9648 103.807 17.4711 103.573 16.9591C103.339 16.4471 103.094 15.9241 102.838 15.3939C102.582 14.8636 102.315 14.3699 102.044 13.9127C101.77 13.4556 101.503 13.0423 101.239 12.6766C100.977 12.3109 100.709 12.0366 100.446 11.8464C100.087 11.5831 99.7149 11.4368 99.3269 11.4149C98.9395 11.3929 98.5189 11.3783 98.0652 11.3783V15.9059L98.076 15.9132ZM98.076 11.0821H99.3235C99.7035 11.0821 100.062 11.0565 100.398 11.0016C100.731 10.9468 101.05 10.859 101.342 10.7347C101.638 10.6103 101.916 10.4238 102.183 10.1751C102.9 9.49122 103.331 8.68299 103.478 7.74677C103.624 6.81419 103.514 5.91819 103.141 5.06244C102.893 4.5029 102.597 4.07867 102.253 3.78975C101.909 3.50084 101.525 3.2997 101.097 3.18267C100.669 3.06564 100.201 3.00347 99.6966 2.99615C99.1915 2.98884 98.6503 2.98518 98.0726 2.98518V11.0821H98.076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.53 2.68164V2.70358C120.908 2.7365 120.418 2.84255 120.059 3.02907C119.701 3.21558 119.43 3.47158 119.244 3.80073C119.057 4.12621 118.941 4.51387 118.893 4.95638C118.845 5.3989 118.823 5.89259 118.823 6.43751V15.9351C118.823 16.48 118.845 16.9737 118.893 17.4162C118.941 17.8588 119.057 18.2464 119.244 18.5719C119.43 18.8974 119.701 19.157 120.059 19.3436C120.418 19.5301 120.901 19.6398 121.507 19.6691H113.455C114.047 19.6398 114.563 19.4935 115.005 19.2375C115.448 18.9815 115.747 18.5353 115.905 17.8953C115.934 17.6759 115.967 17.4089 116 17.0908C116.029 16.7726 116.047 16.3886 116.047 15.9351V6.43751C116.047 5.80117 116.015 5.23067 115.953 4.7333C115.89 4.23593 115.689 3.80804 115.345 3.44964C115.082 3.16804 114.786 2.98153 114.457 2.8901C114.131 2.79501 113.758 2.7365 113.338 2.70358V2.68164H121.53Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.975 4.7333V15.9351C127.975 16.4947 128 16.9957 128.055 17.4419C128.11 17.8844 128.227 18.2647 128.414 18.5865C128.6 18.9047 128.867 19.1571 129.222 19.3436C129.577 19.5301 130.055 19.6398 130.655 19.6691V19.691H124.727V19.6691C125.334 19.6398 125.817 19.5301 126.175 19.3436C126.534 19.1571 126.805 18.9047 126.991 18.5865C127.177 18.2684 127.298 17.888 127.353 17.4419C127.408 16.9993 127.433 16.4983 127.433 15.9351V6.43751C127.433 5.87797 127.408 5.3733 127.353 4.91981C127.298 4.46998 127.177 4.08233 126.991 3.76415C126.805 3.44598 126.53 3.1973 126.175 3.0181C125.817 2.8389 125.334 2.7365 124.727 2.70358V2.68164H129.909L140.109 15.7523V6.43751C140.109 5.87797 140.087 5.37695 140.039 4.93078C139.992 4.48461 139.875 4.10793 139.689 3.7861C139.502 3.46793 139.227 3.21558 138.873 3.02907C138.514 2.84255 138.032 2.73284 137.425 2.70358V2.68164H143.353V2.70358C142.698 2.70358 142.142 2.85353 141.685 3.1461C141.225 3.44233 140.928 3.89215 140.786 4.49924C140.69 4.91981 140.647 5.56347 140.647 6.43751V19.6947H139.853L127.971 4.7333H127.975Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7699 23.7178H59.311L61.059 29.7923L62.9424 23.7178H63.5493L65.4442 29.7923L67.1813 23.7178H67.7224L65.7619 30.4798H65.1442L63.2499 24.3834L61.3482 30.4798H60.7299L58.7699 23.7178Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.288 29.9971V30.4798H71.3932V23.7178H75.2372V24.2005H71.9052V26.8263H74.9955V27.3091H71.9052V29.9934H75.288V29.9971Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7573 29.9971V30.4798H79.0567V23.7178H79.5687V29.9971H82.7573Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0305 29.9971V30.4798H86.3293V23.7178H86.8413V29.9971H90.0305Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5629 23.7178V30.4798H98.1092L94.1189 24.665V30.4798H93.6069V23.7178H94.0532L98.0544 29.5326V23.7178H98.5664H98.5629Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.648 29.9971V30.4798H102.757V23.7178H106.601V24.2005H103.269V26.8263H106.359V27.3091H103.269V29.9934H106.648V29.9971Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.01 28.9956L110.456 28.736C110.686 29.5478 111.374 30.0964 112.485 30.0964C113.597 30.0964 114.186 29.5186 114.186 28.7433C114.186 27.9314 113.473 27.6242 112.438 27.295C111.308 26.9293 110.295 26.6075 110.295 25.4299C110.295 24.3181 111.194 23.6123 112.343 23.6123C113.491 23.6123 114.186 24.2486 114.515 25.0313L114.08 25.2726C113.828 24.6656 113.308 24.1024 112.343 24.1024C111.377 24.1024 110.818 24.6546 110.818 25.408C110.818 26.2198 111.505 26.4722 112.471 26.7904C113.67 27.1853 114.713 27.562 114.713 28.7323C114.713 29.9026 113.835 30.5865 112.493 30.5865C111.228 30.5865 110.328 29.9501 110.021 28.992L110.01 28.9956Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.825 28.9956L118.271 28.736C118.501 29.5478 119.189 30.0964 120.301 30.0964C121.413 30.0964 122.001 29.5186 122.001 28.7433C122.001 27.9314 121.288 27.6242 120.253 27.295C119.123 26.9293 118.11 26.6075 118.11 25.4299C118.11 24.3181 119.01 23.6123 120.158 23.6123C121.306 23.6123 122.001 24.2486 122.33 25.0313L121.895 25.2726C121.643 24.6656 121.123 24.1024 120.158 24.1024C119.193 24.1024 118.633 24.6546 118.633 25.408C118.633 26.2198 119.321 26.4722 120.286 26.7904C121.486 27.1853 122.528 27.562 122.528 28.7323C122.528 29.9026 121.65 30.5865 120.308 30.5865C119.043 30.5865 118.143 29.9501 117.836 28.992L117.825 28.9956Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 31.8872C8.17631 31.8872 1.80923 25.5238 1.80923 17.6975C1.80923 9.87123 8.17265 3.50781 15.9989 3.50781C23.8252 3.50781 30.1887 9.87123 30.1887 17.6975C30.1887 25.5238 23.8252 31.8872 15.9989 31.8872ZM15.9989 3.76016C8.31162 3.76016 2.06158 10.0139 2.06158 17.6975C2.06158 25.3812 8.31528 31.6349 15.9989 31.6349C23.6826 31.6349 29.9363 25.3812 29.9363 17.6975C29.9363 10.0139 23.6826 3.76016 15.9989 3.76016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4024_2000",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 30,
    height: 29
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 31.8872C8.17688 31.8872 1.80978 25.5238 1.80978 17.6975C1.80978 9.87123 8.17322 3.50781 15.9995 3.50781C23.8258 3.50781 30.1892 9.87123 30.1892 17.6975C30.1892 25.5238 23.8258 31.8872 15.9995 31.8872ZM15.9995 3.76016C8.31219 3.76016 2.06213 10.0139 2.06213 17.6975C2.06213 25.3812 8.31585 31.6349 15.9995 31.6349C23.6832 31.6349 29.9369 25.3812 29.9369 17.6975C29.9369 10.0139 23.6832 3.76016 15.9995 3.76016Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4024_2000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.38707 3.75977H2.06158V31.6345H2.38707V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05706 3.75977H2.38416V31.6345H3.05706V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 3.75977H3.06049V31.6345H3.7334V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40582 3.75977H3.73291V31.6345H4.40582V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08273 3.75977H4.40982V31.6345H5.08273V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75569 3.75977H5.08279V31.6345H5.75569V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43262 3.75977H5.7597V31.6345H6.43262V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10617 3.75977H6.43326V31.6345H7.10617V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77805 3.75977H7.10513V31.6345H7.77805V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45493 3.75977H7.78201V31.6345H8.45493V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12738 3.75977H8.45447V31.6345H9.12738V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80426 3.75977H9.13135V31.6345H9.80426V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4773 3.75977H9.80435V31.6345H10.4773V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1541 3.75977H10.4812V31.6345H11.1541V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8271 3.75977H11.1542V31.6345H11.8271V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 3.75977H11.8267V31.6345H12.4996V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1765 3.75977H12.5036V31.6345H13.1765V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8489 3.75977H13.176V31.6345H13.8489V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5258 3.75977H13.8529V31.6345H14.5258V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1988 3.75977H14.5259V31.6345H15.1988V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8746 3.75977H15.2017V31.6345H15.8746V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5487 3.75977H15.8758V31.6345H16.5487V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2211 3.75977H16.5482V31.6345H17.2211V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.898 3.75977H17.2251V31.6345H17.898V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5704 3.75977H17.8975V31.6345H18.5704V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2468 3.75977H18.5739V31.6345H19.2468V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9204 3.75977H19.2474V31.6345H19.9204V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5961 3.75977H19.9232V31.6345H20.5961V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2691 3.75977H20.5962V31.6345H21.2691V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9427 3.75977H21.2697V31.6345H21.9427V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 3.75977H21.9461V31.6345H22.619V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2914 3.75977H22.6185V31.6345H23.2914V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9683 3.75977H23.2954V31.6345H23.9683V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6419 3.75977H23.969V31.6345H24.6419V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3177 3.75977H24.6447V31.6345H25.3177V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9907 3.75977H25.3177V31.6345H25.9907V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6631 3.75977H25.9902V31.6345H26.6631V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3405 3.75977H26.6676V31.6345H27.3405V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.013 3.75977H27.3401V31.6345H28.013V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6899 3.75977H28.017V31.6345H28.6899V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3629 3.75977H28.6899V31.6345H29.3629V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9368 3.75977H29.3663V31.6345H29.9368V3.75977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38396 3.50781H1.80978V31.8836H2.38396V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05706 3.50781H2.38416V31.8836H3.05706V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 3.50781H3.06049V31.8836H3.7334V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40582 3.50781H3.73291V31.8836H4.40582V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08273 3.50781H4.40982V31.8836H5.08273V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75569 3.50781H5.08279V31.8836H5.75569V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43262 3.50781H5.7597V31.8836H6.43262V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10617 3.50781H6.43326V31.8836H7.10617V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77805 3.50781H7.10513V31.8836H7.77805V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45493 3.50781H7.78201V31.8836H8.45493V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12738 3.50781H8.45447V31.8836H9.12738V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80426 3.50781H9.13135V31.8836H9.80426V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4773 3.50781H9.80435V31.8836H10.4773V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1541 3.50781H10.4812V31.8836H11.1541V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8271 3.50781H11.1542V31.8836H11.8271V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 3.50781H11.8267V31.8836H12.4996V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1765 3.50781H12.5036V31.8836H13.1765V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8489 3.50781H13.176V31.8836H13.8489V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5258 3.50781H13.8529V31.8836H14.5258V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1988 3.50781H14.5259V31.8836H15.1988V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8746 3.50781H15.2017V31.8836H15.8746V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5487 3.50781H15.8758V31.8836H16.5487V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2211 3.50781H16.5482V31.8836H17.2211V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.898 3.50781H17.2251V31.8836H17.898V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5704 3.50781H17.8975V31.8836H18.5704V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2468 3.50781H18.5739V31.8836H19.2468V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9204 3.50781H19.2474V31.8836H19.9204V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5961 3.50781H19.9232V31.8836H20.5961V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2691 3.50781H20.5962V31.8836H21.2691V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9427 3.50781H21.2697V31.8836H21.9427V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 3.50781H21.9461V31.8836H22.619V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2914 3.50781H22.6185V31.8836H23.2914V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9683 3.50781H23.2954V31.8836H23.9683V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6419 3.50781H23.969V31.8836H24.6419V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3177 3.50781H24.6447V31.8836H25.3177V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9907 3.50781H25.3177V31.8836H25.9907V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6631 3.50781H25.9902V31.8836H26.6631V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3405 3.50781H26.6676V31.8836H27.3405V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.013 3.50781H27.3401V31.8836H28.013V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6899 3.50781H28.017V31.8836H28.6899V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3629 3.50781H28.6899V31.8836H29.3629V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0392 3.50781H29.3663V31.8836H30.0392V3.50781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1856 3.50781H30.0393V31.8836H30.1856V3.50781Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9582 31.9205C7.15908 31.9205 -0.00161743 24.7598 -0.00161743 15.9607C-0.00161743 7.16165 7.15908 0.000976562 15.9582 0.000976562C24.7573 0.000976562 31.9179 7.16165 31.9179 15.9607C31.9179 24.7598 24.7573 31.9205 15.9582 31.9205ZM15.9582 0.253319C7.2944 0.253319 0.250725 7.29696 0.250725 15.9607C0.250725 24.6245 7.29806 31.6682 15.9582 31.6682C24.6183 31.6682 31.6656 24.6208 31.6656 15.9607C31.6656 7.30062 24.6183 0.253319 15.9582 0.253319Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4024_2000",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 33,
    height: 32
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 31.9215C7.15823 31.9215 -0.00244141 24.7608 -0.00244141 15.9617C-0.00244141 7.16262 7.15823 0.00195312 15.9573 0.00195312C24.7564 0.00195312 31.9171 7.16262 31.9171 15.9617C31.9171 24.7608 24.7564 31.9215 15.9573 31.9215ZM15.9573 0.254296C7.29355 0.254296 0.249901 7.29794 0.249901 15.9617C0.249901 24.6255 7.29721 31.6691 15.9573 31.6691C24.6174 31.6691 31.6647 24.6218 31.6647 15.9617C31.6647 7.3016 24.6174 0.254296 15.9573 0.254296Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4024_2000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.362608 0.253906H0.249237V31.6724H0.362608V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0332 0.253906H0.360291V31.6724H1.0332V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70899 0.253906H1.03607V31.6724H1.70899V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38196 0.253906H1.70905V31.6724H2.38196V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05441 0.253906H2.3815V31.6724H3.05441V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73129 0.253906H3.05838V31.6724H3.73129V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4043 0.253906H3.73138V31.6724H4.4043V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08118 0.253906H4.40826V31.6724H5.08118V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75418 0.253906H5.08127V31.6724H5.75418V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43051 0.253906H5.7576V31.6724H6.43051V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10352 0.253906H6.4306V31.6724H7.10352V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77594 0.253906H7.10303V31.6724H7.77594V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45285 0.253906H7.77994V31.6724H8.45285V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12583 0.253906H8.45291V31.6724H9.12583V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80274 0.253906H9.12982V31.6724H9.80274V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4757 0.253906H9.8028V31.6724H10.4757V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1515 0.253906H10.4786V31.6724H11.1515V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.825 0.253906H11.1521V31.6724H11.825V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4975 0.253906H11.8246V31.6724H12.4975V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 0.253906H12.5009V31.6724H13.1738V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8474 0.253906H13.1745V31.6724H13.8474V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5243 0.253906H13.8513V31.6724H14.5243V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1973 0.253906H14.5244V31.6724H15.1973V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.873 0.253906H15.2001V31.6724H15.873V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5466 0.253906H15.8737V31.6724H16.5466V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2185 0.253906H16.5456V31.6724H17.2185V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8954 0.253906H17.2224V31.6724H17.8954V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5689 0.253906H17.896V31.6724H18.5689V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2447 0.253906H18.5718V31.6724H19.2447V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9188 0.253906H19.2459V31.6724H19.9188V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5946 0.253906H19.9217V31.6724H20.5946V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2676 0.253906H20.5947V31.6724H21.2676V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.94 0.253906H21.2671V31.6724H21.94V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6169 0.253906H21.944V31.6724H22.6169V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2899 0.253906H22.617V31.6724H23.2899V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9662 0.253906H23.2933V31.6724H23.9662V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6392 0.253906H23.9663V31.6724H24.6392V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3161 0.253906H24.6432V31.6724H25.3161V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9891 0.253906H25.3162V31.6724H25.9891V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6615 0.253906H25.9886V31.6724H26.6615V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3384 0.253906H26.6655V31.6724H27.3384V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0114 0.253906H27.3385V31.6724H28.0114V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6872 0.253906H28.0143V31.6724H28.6872V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3608 0.253906H28.6878V31.6724H29.3608V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0377 0.253906H29.3647V31.6724H30.0377V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7106 0.253906H30.0377V31.6724H30.7106V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3831 0.253906H30.7102V31.6724H31.3831V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.665 0.253906H31.3871V31.6724H31.665V0.253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.359616 0.00195312H-0.00244141V31.9215H0.359616V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0332 0.00195312H0.360291V31.9215H1.0332V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70899 0.00195312H1.03607V31.9215H1.70899V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38196 0.00195312H1.70905V31.9215H2.38196V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05441 0.00195312H2.3815V31.9215H3.05441V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73129 0.00195312H3.05838V31.9215H3.73129V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4043 0.00195312H3.73138V31.9215H4.4043V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08118 0.00195312H4.40826V31.9215H5.08118V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75418 0.00195312H5.08127V31.9215H5.75418V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43051 0.00195312H5.7576V31.9215H6.43051V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10352 0.00195312H6.4306V31.9215H7.10352V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77594 0.00195312H7.10303V31.9215H7.77594V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45285 0.00195312H7.77994V31.9215H8.45285V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12583 0.00195312H8.45291V31.9215H9.12583V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80274 0.00195312H9.12982V31.9215H9.80274V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4757 0.00195312H9.8028V31.9215H10.4757V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1515 0.00195312H10.4786V31.9215H11.1515V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.825 0.00195312H11.1521V31.9215H11.825V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4975 0.00195312H11.8246V31.9215H12.4975V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 0.00195312H12.5009V31.9215H13.1738V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8474 0.00195312H13.1745V31.9215H13.8474V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5243 0.00195312H13.8513V31.9215H14.5243V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1973 0.00195312H14.5244V31.9215H15.1973V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.873 0.00195312H15.2001V31.9215H15.873V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5466 0.00195312H15.8737V31.9215H16.5466V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2185 0.00195312H16.5456V31.9215H17.2185V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8954 0.00195312H17.2224V31.9215H17.8954V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5689 0.00195312H17.896V31.9215H18.5689V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2447 0.00195312H18.5718V31.9215H19.2447V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9188 0.00195312H19.2459V31.9215H19.9188V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5946 0.00195312H19.9217V31.9215H20.5946V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2676 0.00195312H20.5947V31.9215H21.2676V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.94 0.00195312H21.2671V31.9215H21.94V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6169 0.00195312H21.944V31.9215H22.6169V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2899 0.00195312H22.617V31.9215H23.2899V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9662 0.00195312H23.2933V31.9215H23.9662V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6392 0.00195312H23.9663V31.9215H24.6392V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3161 0.00195312H24.6432V31.9215H25.3161V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9891 0.00195312H25.3162V31.9215H25.9891V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6615 0.00195312H25.9886V31.9215H26.6615V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3384 0.00195312H26.6655V31.9215H27.3384V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0114 0.00195312H27.3385V31.9215H28.0114V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6872 0.00195312H28.0143V31.9215H28.6872V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3608 0.00195312H28.6878V31.9215H29.3608V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0377 0.00195312H29.3647V31.9215H30.0377V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7106 0.00195312H30.0377V31.9215H30.7106V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3831 0.00195312H30.7102V31.9215H31.3831V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9173 0.00195312H31.3871V31.9215H31.9173V0.00195312Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25835 13.54C10.4067 17.8994 12.3377 21.999 14.9379 25.6635C15.2743 26.1426 15.6327 26.618 15.9948 27.0824V28.282L15.9875 28.2747C15.6547 28.0918 2.52921 20.6715 9.25469 13.54H9.25835Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0556 25.6635C19.6559 21.999 21.5868 17.8994 22.7352 13.54C29.4607 20.6715 16.3352 28.0918 16.0024 28.2747L15.9951 28.282V27.0824C16.3571 26.6143 16.7155 26.1426 17.052 25.6635H17.0556Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8712 29.5725C21.4991 27.1807 24.6442 24.1197 27.142 20.543C28.3269 30.5014 15.9951 31.7631 15.9951 31.7631V30.7354C16.6351 30.3734 17.2604 29.9857 17.8712 29.5725Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8515 20.54C7.34932 24.1167 10.4945 27.1814 14.1224 29.5695C14.7294 29.9828 15.3585 30.3668 15.9985 30.7325V31.7602C15.9985 31.7602 3.66659 30.4984 4.8515 20.54Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9985 8.25977V23.9818C15.9619 23.9379 8.77566 14.956 15.9985 8.25977Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 23.9818V8.25977C23.2218 14.9523 16.0355 23.9343 15.999 23.9818Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 0.216797V8.18568C15.9738 8.16374 10.8721 3.61062 15.9994 0.216797Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.18568V0.216797C21.1263 3.61062 16.0246 8.16374 15.999 8.18568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4024_2000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.429,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.e41f04df7322c8914be2e406f75b2301.svg";
export { ForwardRef as ReactComponent };